var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 38.5,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 26.8,
  width: 6,
  height: 6.5,
  rx: 2,
  fill: "#3c4652"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 15.4,
  y: 33,
  width: 7.2,
  height: 1.9,
  rx: 0.9,
  fill: "#3c4652"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 18.35,
  y: 34.9,
  width: 1.3,
  height: 2.4,
  fill: "#5c6870"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 16.3,
  y: 37.3,
  width: 5.9,
  height: 1.1,
  rx: 0.55,
  fill: "#5c6870"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 26.8,
  width: 6,
  height: 6.5,
  rx: 2,
  fill: "#3c4652"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 22.4,
  y: 33,
  width: 7.2,
  height: 1.9,
  rx: 0.9,
  fill: "#3c4652"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 25.35,
  y: 34.9,
  width: 1.3,
  height: 2.4,
  fill: "#5c6870"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 23.3,
  y: 37.3,
  width: 5.9,
  height: 1.1,
  rx: 0.55,
  fill: "#5c6870"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 28.7,
  width: 1.7,
  height: 7,
  fill: "#8a6238"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 30.5,
  y: 28.7,
  width: 1.7,
  height: 7,
  fill: "#8a6238"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 10.5,
  y: 26.3,
  width: 24.1,
  height: 2.4,
  rx: 1.1,
  fill: "#c8925a"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 8.47) scale(0.78)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 15.6,
  r: 3.4,
  fill: "#5a8fd8"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4.5,
  y: 19,
  width: 7,
  height: 11,
  rx: 3,
  fill: "#5a8fd8"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 19.8,
  width: 6.5,
  height: 2.2,
  rx: 1.1,
  fill: "#5a8fd8",
  transform: "rotate(33 10 20.9)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.8,
  cy: 24.2,
  r: 1.2,
  fill: "#5a8fd8"
}), /*#__PURE__*/React.createElement("rect", {
  x: 5.3,
  y: 30,
  width: 2.6,
  height: 8.5,
  rx: 1,
  fill: "#4a77b8"
}), /*#__PURE__*/React.createElement("rect", {
  x: 8.7,
  y: 30,
  width: 2.6,
  height: 8.5,
  rx: 1,
  fill: "#4a77b8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8.7 36.9h3c0.9 0 1.3 0.4 1.3 0.85 0 0.4-0.3 0.75-0.7 0.75h-3.6z",
  fill: "#31281f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.3 36.9h3c0.9 0 1.3 0.4 1.3 0.85 0 0.4-0.3 0.75-0.7 0.75h-3.6z",
  fill: "#31281f"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 8.47) scale(0.78)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 37.5,
  cy: 15.6,
  r: 3.4,
  fill: "#23967f"
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 19,
  width: 7,
  height: 11,
  rx: 3,
  fill: "#23967f"
}), /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 19.8,
  width: 6.5,
  height: 2.2,
  rx: 1.1,
  fill: "#23967f",
  transform: "rotate(-33 35.5 20.9)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30.2,
  cy: 24.2,
  r: 1.2,
  fill: "#23967f"
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.7,
  y: 30,
  width: 2.6,
  height: 8.5,
  rx: 1,
  fill: "#1a6e5c"
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.1,
  y: 30,
  width: 2.6,
  height: 8.5,
  rx: 1,
  fill: "#1a6e5c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m36.3 36.9h-3c-0.9 0-1.3 0.4-1.3 0.85 0 0.4 0.3 0.75 0.7 0.75h3.6z",
  fill: "#31281f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m39.7 36.9h-3c-0.9 0-1.3 0.4-1.3 0.85 0 0.4 0.3 0.75 0.7 0.75h3.6z",
  fill: "#31281f"
}));

function SvgMeetingRoomSetup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoomSetup);
export default __webpack_public_path__ + "static/media/meeting-room-setup.2ed4bc895922caadbb049c2d43479acb.svg";
export { ForwardRef as ReactComponent };